<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">ロール編集</h4>	
						
						<div class="el-table__body-wrapper table-responsive">
							
							
                            <div class="form-group" v-bind:class="{  'text-danger has-error': errors.name }">
                                  <label for="title">ロール名<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="roleName" class="form-control" name="roleName" id="roleName" />
                                    <p v-for="(error,key) in errors.name" :key="key" class="error-text" >{{error}}</p>
                              
                            </div>
							<div class="form-group">
                                <label >許可<span class="badge badge-required">必須</span></label>
                                <ul  class="checkbox-container">
                                    <li class="form-check" v-for="(permission,key) in permissionData" :key="key">
                                      <input type="checkbox"  v-model="permissionSelected" :value="permission.id" class="form-check-input"  :id="permission.name" :checked="permission.checked"  >
									  <label class="form-check-label" :for="permission.name">{{ permission.label_jp }}</label>
                                    </li>
                                </ul>
                                 <p v-for="(error,key) in errors.permission" :key="key" class="error-text" >{{error}}</p>
                              </div>

							<div class="btn-wrap form-group text-center">
								<a class="btn btn-primary" href="/roles/">戻る</a>
                                <button  class="btn btn-primary" @click="update" :disabled="loading" >更新</button> 
							</div>
 							<div class="loading" v-show="loading">受信中...</div>
						</div>	
					</div>
                </div>
            </div>
			
		</div>
	</div>
</template>

<script>

export default {
	props: ['role', 'permission'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			permissionData: {},
			rolePermissionData: {},
			roleData:{},
			permissionSelected:[],
			loading: false,
			roleName:"",
			errors:{},
			siteId:0
		}
	},

	mounted() {
		
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		this.permissionData = JSON.parse(this.permission)
		this.roleData = JSON.parse(this.role)
		this.roleName = this.roleData.name 
        for(let i=0; i < (this.permissionData).length; i++) {
			if(this.permissionData[i].checked) {
				this.permissionSelected.push(this.permissionData[i].id)
			}
		}
		//this.roleData = JSON.parse(this.role)
		//console.log(this.permissionData.length)
		//console.log(this.rolePermissionData.length)
	},

	computed: {

	},
	methods: {
		update : function() {
			
			this.loading = true;
			this.errors = {};
			axios.post('/roles/' + this.roleData.id, { 
				'_method':'PUT',
				'name': this.roleName,
				'permission': this.permissionSelected
			}).then(response => {
				this.loading = false;
				//this.info = response.data.info;
				this.$toast(response.data.info, {
				toastClassName: "toaster"
				})
				//this.id = response.data.result.id;
				
			}).catch(error => {
				console.log(error)
				if (error.response.status === 422) {
					this.errors = error.response.data.errors || {};
					//this.info = error.response.data.info;
					this.$toast(error.response.data.info, {
						toastClassName: "toaster"
					})
					this.error = true;
           			this.loading = false;
        		}
      		});
		}
	}

}
</script>

<style scoped>

.label-success {
	margin: 5px;
	padding: 2px;
	
}
</style>